export default "__VITE_ASSET__Lj6RWcYg__"